import PublicSiteLayout from "@/components/layouts/PublicSiteLayout";
import Seo from "@/components/marketing/Seo";
import Learn from "./Learn";

const PublicLearn = () => {
  return (
    <PublicSiteLayout>
      <Seo
        title="Coach U | Interview Prep Articles, Job Search Advice, and Career Guides"
        description="Coach U by HiredCoach is the public library for interview prep, job search advice, and practical guides you can use before your next interview."
        canonicalPath="/public-learn"
        keywords="Coach U, interview prep articles, job search advice, career guides, HiredCoach"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Coach U",
          description:
            "Coach U by HiredCoach is a public library of interview prep, job search advice, and career development guides.",
          url: "https://hiredcoach.ai/public-learn",
        }}
      />
      <Learn mode="public" withDashboard={false} />
    </PublicSiteLayout>
  );
};

export default PublicLearn;
